import { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Sidebar from '@/components/feature/Sidebar';

function App() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <div className="flex min-h-screen" style={{ background: '#0a0a0f', fontFamily: 'Inter, sans-serif' }}>
          <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
          <main
            className="flex-1 overflow-auto transition-all duration-300"
            style={{ marginLeft: collapsed ? '64px' : '256px' }}
          >
            <div className="p-6 min-h-screen">
              <AppRoutes />
            </div>
          </main>
        </div>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
